import { addStyles } from '../components/theme';
import { T, Translate } from '../i18n';
import type { MithrilVNode } from '../mithril';
import { m } from '../mithril';
import { FormDesigner } from '../modules/form.designer/form.designer';
import { Services } from '../services';
import { AppStore } from '../store';
import { IkePage, type IkePageConfig, IkePageName } from './page';

export const CSS = {
	container: 'c-FormEdit',
};

const Style = {
	[CSS.container]: {
		height: '100%',
		width: '80%',
	},
};

addStyles(Style);

export const FormEditPageConfig: IkePageConfig = {
	type: 'internal',
	name: IkePageName.formEdit,
	path: '/form/edit/:version',
	auth: {
		required: true,
	},
};

export class FormEditPage extends IkePage {
	private designer: FormDesigner | null = null;
	private formVersion?: string;

	constructor() {
		super(FormEditPageConfig);
	}

	init() {
		const formVersion = Services.Route.params.get('version');
		if (!formVersion) {
			Services.Log.Logger.error('form version not found in route');
			return;
		}

		this.formVersion = formVersion;
		this.designer = new FormDesigner();
		this.designer.setEditing(true);

		AppStore.Form.fetch(this.formVersion)
			.then((form) => this.designer?.setForm(form))
			.catch((e) => Services.Log.Logger.error(e));
	}

	get nodes(): MithrilVNode {
		if (this.designer == null || !this.formVersion) {
			this.init();
		}

		if (Services.Department.current == null) {
			Services.Log.Logger.error('current department is not set');
			return null;
		}

		if (!this.formVersion) {
			Services.Log.Logger.error('form version is not set');
			return null;
		}

		if (!this.designer) {
			Services.Log.Logger.error('designer is not set');
			return null;
		}

		if (!Services.User.current) {
			Services.Log.Logger.error('no current user');
			return null;
		}

		const userProfile = Services.UserProfile.get(Services.User.current.objectId);

		if (userProfile && !Services.UserProfile.canEditForms(userProfile)) {
			Services.Log.Logger.error('user cannot edit forms');
			return null;
		}

		if (!AppStore.Form.exists(this.formVersion)) {
			return m('div', { className: CSS.container }, Translate(T.FORM_NOT_FOUND));
		}

		if (this.designer.form == null) {
			return m('div', { className: CSS.container });
		}

		return m('div', { className: CSS.container }, this.designer.view());
	}

	override onRemove() {
		if (this.designer != null) {
			this.designer.onRemove();
			this.designer = null;
		}
	}
}
